module.exports = __webpack_public_path__ + "static/media/htkj.a1bb59ae.png";